/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
import Component from '@glimmer/component';
export default class SecureContactRowBaseComponent extends Component {
  constructor() {
    super(...arguments);
  }
  get detailClassname() {
    let selector = this.args.detail?.phone ? 'phone' : 'email';
    if (this.args.bottomDivider) {
      selector += ' bottom-divider';
    }
    return selector;
  }
  get verifiedAt() {
    return new Date(this.args.detail.verified_at).toLocaleDateString();
  }
}